import Conference1 from "./Conference1";

const conferences = {
    1: Conference1
};

export default conferences;